import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FaDesktop, FaStop } from "react-icons/fa";
import LocalScreenSharingPreview from "./LocalScreenSharingPreview";
import * as webRTCHandler from "../../utils/webRTCHandler";
import * as wss from "../../utils/wss";
import { setScreenSharingUser } from "../../store/actions";

const constraints = {
  audio: false,
  video: true,
};

const SwitchToScreenSharingButton = () => {
  const dispatch = useDispatch();
  const identity = useSelector((state) => state.identity);
  const screenSharingUser = useSelector((state) => state.screenSharingUser);
  const roomId = useSelector((state) => state.roomId);

  const [isScreenSharingActive, setIsScreenSharingActive] = useState(false);
  const [screenSharingStream, setScreenSharingStream] = useState(null);

  // Check if another user is sharing (not the current user)
  const isAnotherUserSharing = screenSharingUser && screenSharingUser !== identity;

  const handleScreenShareToggle = async () => {
    // Don't allow starting screen share if another user is already sharing
    if (isAnotherUserSharing) {
      alert(`${screenSharingUser} is already sharing their screen.`);
      return;
    }

    if (!isScreenSharingActive) {
      let stream = null;
      try {
        stream = await navigator.mediaDevices.getDisplayMedia(constraints);
      } catch (err) {
        console.error("Error accessing screen share stream", err);
      }

      if (stream) {
        setScreenSharingStream(stream);
        webRTCHandler.toggleScreenShare(isScreenSharingActive, stream);
        setIsScreenSharingActive(true);
        dispatch(setScreenSharingUser(identity));
        // Notify server and other users
        wss.startScreenShare(roomId, identity);
      }
    } else {
      webRTCHandler.toggleScreenShare(isScreenSharingActive);
      setIsScreenSharingActive(false);

      if (screenSharingStream) {
        screenSharingStream.getTracks().forEach((t) => t.stop());
        setScreenSharingStream(null);
      }

      dispatch(setScreenSharingUser(null));
      // Notify server and other users
      wss.stopScreenShare(roomId);
    }
  };

  // Determine if button should be disabled
  const isButtonDisabled = isAnotherUserSharing && !isScreenSharingActive;

  return (
    <>
      <div
        className={`video_button_container tooltip mdevice ${isButtonDisabled ? 'disabled' : ''}`}
        onClick={handleScreenShareToggle}
        data-tooltip={isScreenSharingActive ? "Stop Sharing" : isAnotherUserSharing ? `${screenSharingUser} is sharing` : "Share Screen"}
        style={{ opacity: isButtonDisabled ? 0.5 : 1, cursor: isButtonDisabled ? 'not-allowed' : 'pointer' }}
      >
        <span className={`video_button_icon ${isScreenSharingActive ? 'active' : ''}`}>
          {isScreenSharingActive ? (
            <FaStop size={20} />
          ) : (
            <FaDesktop size={20} />
          )}
        </span>
        <span className="video_button_label">{isScreenSharingActive ? "Stop Share" : "Share"}</span>
      </div>
      {isScreenSharingActive && (
        <LocalScreenSharingPreview stream={screenSharingStream} />
      )}
    </>
  );
};

export default SwitchToScreenSharingButton;
